import eventBus from './eventBus'

const notification = data => {
  eventBus.dispatch('createNotification', data)
}

export { notification }
